import React, { FunctionComponent } from "react";
import { Box, Text } from "@chakra-ui/react";
import { fonts } from "@/theme/fonts";
import { ChakraFAIcon } from "@/components/ui/Icon";

interface ListedFeatureProps {
	iconName: string;
	title: string;
	description: string;
}

export const ListedFeature: FunctionComponent<ListedFeatureProps> = ({ iconName, title, description }) => {
	return (
		<Box display="flex" alignItems="center" mb={8} gap={4}>
			<Box borderRadius="md" bg="accent.turquoise.100" w={14} h={14} display="flex" alignItems="center" justifyContent="center">
				<ChakraFAIcon icon={iconName} variant="solid" color="text.link.default" boxSize={5} />
			</Box>
			<Box>
				<Text fontSize="lg" fontWeight={500} fontFamily={fonts.heading}>
					{title}
				</Text>
				<Text color="neutral.300">{description}</Text>
			</Box>
		</Box>
	);
};
